import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import ro from 'javascript-time-ago/locale/ro';
import { useMemo } from 'react';
import { useLocale } from '@contexts/LocaleContext';

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ro);

// Hook that integrates with LocaleContext for reactive locale changes
export const useTimeAgo = () => {
  const { locale } = useLocale();

  return useMemo(() => {
    return new TimeAgo(locale);
  }, [locale]);
};
